<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'filters.subtitle' | t }}</p>
    </div>
    <button class="ct-btn ct-btn-primary" type="button" (click)="openCreateFilter()">
      {{ 'filters.new' | t }}
    </button>
  </div>

  <div class="grid">
    <aside class="ct-card panel">
      <h3>{{ 'filters.leafCategory' | t }}</h3>
      <div class="list">
        @for (cat of leafCategories(); track cat.id) {
          <button
            type="button"
            class="list-item"
            [class.active]="selectedCategoryId() === cat.id"
            (click)="selectCategory(cat.id)"
          >
            <strong>{{ cat.name }}</strong>
            <small>{{ cat.parentName }}</small>
          </button>
        } @empty {
          <p class="empty">{{ 'filters.noLeaf' | t }}</p>
        }
      </div>
    </aside>

    <div class="stack">
      <div class="ct-card panel">
        <div class="panel__head">
          <h3>{{ 'filters.assigned' | t }}</h3>
          @if (assignedFilters().length) {
            <button class="ct-btn ct-btn-primary ct-btn-sm" type="button" (click)="saveAssignedOrder()">
              {{ 'filters.saveOrder' | t }}
            </button>
          }
        </div>
        <div class="chips">
          @for (filter of assignedFilters(); track filter.id; let i = $index) {
            <div class="chip">
              <div class="chip__order">
                <button
                  type="button"
                  class="order-btn"
                  [disabled]="i === 0"
                  (click)="moveAssigned(i, -1)"
                  [attr.aria-label]="'filters.moveUp' | t"
                  [attr.title]="'filters.moveUp' | t"
                >
                  ↑
                </button>
                <button
                  type="button"
                  class="order-btn"
                  [disabled]="i === assignedFilters().length - 1"
                  (click)="moveAssigned(i, 1)"
                  [attr.aria-label]="'filters.moveDown' | t"
                  [attr.title]="'filters.moveDown' | t"
                >
                  ↓
                </button>
              </div>
              <div class="chip__body">
                <strong>{{ filter.name }}</strong>
                <small>{{ valueTypeLabel(filter.valueType) }}</small>
              </div>
              <button
                class="ct-btn ct-btn-danger ct-btn-sm"
                type="button"
                (click)="unassign(filter.id, filter.name)"
              >
                {{ 'filters.remove' | t }}
              </button>
            </div>
          } @empty {
            <p class="empty">{{ 'filters.noneAssigned' | t }}</p>
          }
        </div>
      </div>

      <div class="ct-card panel">
        <h3>{{ 'filters.available' | t }}</h3>
        <div class="chips">
          @for (filter of availableFilters(); track filter.id) {
            <div class="chip">
              <div>
                <strong>{{ filter.name }}</strong>
                <small>{{ valueTypeLabel(filter.valueType) }}</small>
              </div>
              <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="assign(filter.id)">
                {{ 'filters.assign' | t }}
              </button>
            </div>
          } @empty {
            <p class="empty">{{ 'filters.noneAvailable' | t }}</p>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="ct-section-head">
    <h3>{{ 'filters.catalog' | t }}</h3>
  </div>
  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th>{{ 'common.name' | t }}</th>
          <th>{{ 'common.type' | t }}</th>
          <th>{{ 'common.system' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (filter of allFilters(); track filter.id) {
          <tr>
            <td>{{ filter.name }}</td>
            <td>{{ valueTypeLabel(filter.valueType) }}</td>
            <td>{{ (filter.isSystem ? 'common.yes' : 'common.no') | t }}</td>
            <td class="col-status">
              <span class="ct-badge" [class.ct-badge-success]="filter.isActive" [class.ct-badge-muted]="!filter.isActive">
                {{ (filter.isActive ? 'common.active' : 'common.inactive') | t }}
              </span>
            </td>
            <td class="actions">
              <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEditFilter(filter)">
                {{ 'common.edit' | t }}
              </button>
              @if (!filter.isSystem) {
                <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="removeFilter(filter)">
                  {{ 'common.delete' | t }}
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>

@if (filterDialogOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeFilterDialog()">
    <div class="ct-dialog wide" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ (editingFilterId() ? 'filters.edit' : 'filters.new') | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeFilterDialog()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button></header>
      <form [formGroup]="filterForm" (ngSubmit)="saveFilter()">
        <div class="ct-dialog-body">
        <div class="ct-form-grid">
          <div class="ct-field">
            <label for="fname">{{ 'common.name' | t }}</label>
            <input id="fname" class="ct-input" formControlName="name" />
          </div>
          <div class="ct-field">
            <label for="ftype">{{ 'filters.valueType' | t }}</label>
            <select
              id="ftype"
              class="ct-select"
              formControlName="valueType"
              (change)="onValueTypeChange()"
            >
              @for (type of valueTypes; track type) {
                <option [ngValue]="type">{{ type }}</option>
              }
            </select>
          </div>
          <div class="ct-field">
            <label>
              <input type="checkbox" formControlName="isActive" /> {{ 'common.active' | t }}
            </label>
          </div>
        </div>

        @if (isOptionsType()) {
          <div class="options-editor">
            <div class="options-editor__head">
              <h3>{{ 'filters.options' | t }}</h3>
              <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="addOption()">
                {{ 'filters.addOption' | t }}
              </button>
            </div>
            <p class="hint">{{ 'filters.optionsHint' | t }}</p>
            @for (opt of optionDrafts(); track $index; let i = $index) {
              <div class="option-row">
                <input
                  class="ct-input"
                  [placeholder]="'filters.optionLabel' | t"
                  [ngModel]="opt.label"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="setOptionField(i, 'label', $event)"
                />
                <input
                  class="ct-input"
                  [placeholder]="'filters.optionValue' | t"
                  [ngModel]="opt.value"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="setOptionField(i, 'value', $event)"
                />
                <button
                  class="ct-btn ct-btn-danger ct-btn-sm"
                  type="button"
                  (click)="removeOption(i)"
                  [disabled]="optionDrafts().length <= 1"
                >
                  {{ 'common.delete' | t }}
                </button>
              </div>
            }
          </div>
        }

        </div>
        <div class="ct-dialog-actions">
          <button class="ct-btn ct-btn-ghost" type="button" (click)="closeFilterDialog()">
            {{ 'common.cancel' | t }}
          </button>
          <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
        </div>
      </form>
    </div>
  </div>
}
